/**
 * Controller: PricingDiscountsCreateModal
 */
angular.module('acme.view.application.pricing.discounts.createModal.controllers', [])
.controller('PricingDiscountsCreateModalController', [ '$scope', '$uibModalInstance', 'discountsList', function ($scope, $uibModalInstance, discountsList) {

    $scope.errors = [];

    $scope.model = {
      name: '',
      description: '',
      code: ''
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=discountsList.length;i<ii;i++) {
        trimmed = $scope.trim(discountsList[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.isValid = function(prop) {
      var r = true;

      r = ($scope.model[prop].replace(/\s+/g, '').length > 0);

      return r;
    };

    $scope.done = function() {
      $scope.errors = [];
      if ($scope.isUnique()) {
        if( !$scope.isValid('code') ){
          $scope.errors.push({ message: 'Please enter a valid code'});
        }
        else if( !$scope.isValid('name') ){
          $scope.errors.push({ message: 'Please enter a valid name'});
        }
        else if( !$scope.isValid('description') ){
          $scope.errors.push({ message: 'Please enter a valid description'});
        }
        else {
          $scope.success();
        }
      }else{
        $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);